import React from 'react';
import hsidLogo from '../../assets/images/logo-hsid.png';
import classes from './HSIDLogo.css';

const logo = (props) => (
    <div className={classes.Logo}>
        <img src={hsidLogo} alt={props.logoName} />
        {props.children}
    </div>
);

export default logo;